import layout from '@/views/layout/layout.vue'
const stockList = r => require.ensure([], () => r(require('@/views/antiChannelConflict/stock/list.vue')), 'group-antiChannelConflict-stock')

const antiChannelConflictStock = [
  {
    path: '/antichannelconflict/stock',
    name: 'antiChannelConflict-stock',
    component: layout,
    redirect: '/antichannelconflict/stock/list',
    children: [
      {
        path: 'list',
        component: stockList,
        name: 'antiChannelConflict-stock-list',
        meta: {
          displayName: '库存查询',
          requireAuth: true
        }
      }
    ]
  }
]

export default antiChannelConflictStock



// WEBPACK FOOTER //
// ./src/router/antiChannelConflict/stock.js